import { createTheme } from '@material-ui/core';

export const themeObject = {
  palette: {
    primary: {
      main: '#FD9E20',
    },
  },
  typography: {
    fontFamily: 'Montserrat',
  },

  overrides: {
    MuiIcon: {
      root: {
        color: 'red',
      },
    },
    MuiInput: {
      root: {
        width: '100%',
        height: '48px',
        paddingLeft: '48px',
        backgroundColor: 'var(--color-white)',
        borderRadius: 11,
        border: 'none',
        boxShadow:
          '0px -1px 4px 0px var(--color-gray-shadow), 0px 4px 0px 0px var(--color-main-orange)',
        color: 'var(--color-light-gray-font)',
        fontSize: '16px',
        fontWeight: 300,

        '&:hover': {
          border: 'none',
        },
        '&$error': {
          boxShadow:
            '0px -1px 4px 0px var(--color-gray-shadow), 0px 4px 0px 0px var(--color-red)',
        },

        '&>input': {
          padding: 0,
        },
      },
    },
  },

  props: {
    MuiInput: {
      disableUnderline: true,
    },
  },
};

export const theme = createTheme(themeObject);
